import request from '@/plugin/axios'


export function GetUserCombo(data) {
	return request({
		url: '/GetUserCombo',
		method: 'post',
		data: data
	})
}

// 获取数据权限控制的模块名
export function GetModelNameCombo(data) {
	return request({
		url: '/GetModelNameCombo',
		method: 'post',
		data: data
	})
}

// 根据手机同步企业微信
export function UpdateWeUserPhone(data) {
	return request({
		url: '/UpdateWeUserPhone',
		method: 'post',
		data: data
	})
}

// 测试企业微信推送
export function TrySendWeTextMsg(data) {
	return request({
		url: '/TrySendWeTextMsg',
		method: 'post',
		data: data
	})
}

// 获取用户角色
export function GetUserRoles(data) {
	return request({
		url: '/GetUserRoles',
		method: 'post',
		data: data
	})
}

// 以下是基础的增删改查
export function GetAllUser(data) {
	return request({
		url: '/GetAllUser',
		method: 'post',
		data: data
	})
}

export function GetUserByID(data) {
	return request({
		url: '/GetUserByID',
		method: 'post',
		data: data
	})
}

export function AddUser(data) {
	return request({
		url: '/AddUser',
		method: 'post',
		data: data
	})
}

export function UpdateUser(data) {
	return request({
		url: '/UpdateUser',
		method: 'post',
		data: data
	})
}

export function DeleteUsers(data) {
	return request({
		url: '/DeleteUsers',
		method: 'post',
		data: data
	})
}

export function UpdateUserPasswordByID(data) {
	return request({
		url: '/UpdateUserPasswordByID',
		method: 'post',
		data: data
	})
}

export function UpdateMyPassword(data) {
	return request({
		url: '/UpdateMyPassword',
		method: 'post',
		data: data
	})
}

export function UpdateUserByID(data) {
	return request({
		url: '/UpdateUserByID',
		method: 'post',
		data: data
	})
}

export function DeleteUser(data) {
	return request({
		url: '/DeleteUser',
		method: 'post',
		data: data
	})
}

export function GetAllUserOption(data) {
	return request({
		url: '/GetAllUserOption',
		method: 'post',
		data: data
	})
}

export function UpdateUsersAuth(data) {
	return request({
		url: '/UpdateUsersAuth',
		method: 'post',
		data: data
	})
}

